var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 57,
    viewBox: "0 0 23 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0231 35.7748V6.57786C18.0231 2.95882 15.0998 0 11.5 0C7.90021 0 4.97689 2.95882 4.97689 6.57786V35.7748C1.88445 37.9266 0 41.5457 0 45.3604C0 51.7671 5.17017 57 11.5 57C17.8298 57 23 51.7671 23 45.3604C23 41.5457 21.1155 37.9511 18.0231 35.7748ZM11.5 54.2613C6.64391 54.2613 2.70588 50.2754 2.70588 45.3604C2.70588 42.2304 4.3729 39.296 7.03046 37.7066C7.44118 37.462 7.68277 37.0219 7.68277 36.5328V6.57786C7.68277 4.45045 9.39811 2.73874 11.5 2.73874C13.6019 2.73874 15.2931 4.4749 15.2931 6.57786V36.5084C15.2931 36.9974 15.5347 37.4376 15.9454 37.6821C18.6029 39.2716 20.27 42.2059 20.27 45.3359C20.2941 50.2754 16.3561 54.2613 11.5 54.2613Z",
    fill: "#ED1C24",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5777 38.2445V22.9858C13.5777 21.8366 12.6597 20.8829 11.5 20.8829C10.3645 20.8829 9.42227 21.8121 9.42227 22.9858V38.2445C6.37815 39.1493 4.15546 41.9858 4.15546 45.3604C4.15546 49.4685 7.44118 52.7696 11.4758 52.7696C15.5347 52.7696 18.7962 49.444 18.7962 45.3604C18.8204 41.9858 16.5977 39.1493 13.5777 38.2445Z",
    fill: "#ED1C24",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/temperature_icon.3955e747caf8be5cbbfc678ab0aaa8b3.svg";
export { ForwardRef as ReactComponent };